<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
    <span>Loading...</span>
  </div>
}
  @if (!showFormLoader) {
<div class="panel panel-default">
    <div class="panel-body">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
            <input type="text" class="form-control" id="tax-year" name="tax-year" [ngModel]="chartRoll.TAX_YEAR" readonly>
            @if (TAX_YEAR_NOT_VALID && !chartRoll.TAX_YEAR) {
<small class="text-danger">Please provide To Tax Year</small>
}
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="prior-year-key"><b>Prior Year Key<sup>*</sup>:</b></label>
            <select class="form-control" id="prior-year-key" name="prior-year-key"
              [ngModel]="chartRoll.PRIOR_YR_KEY"
              (ngModelChange)="chartRoll.PRIOR_YR_KEY = $event; changePriorYearKey()">
              <option [ngValue]="null">Select</option>
              @for (s of chartKeyList; track $index) {
<option [ngValue]="s">{{ getPriorKeyLabel(s) }}</option>
}
            </select>
            @if (PRIOR_YR_KEY_KEY_NOT_VALID) {
<small class="text-danger">Please provide Prior Year Key</small>
}
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="chart-code"><b>Chart Code<sup>*</sup>:</b></label>
            <input type="text" class="form-control" id="chart-code" name="chart-code" [ngModel]="chartRoll.CURR_YR_CHART_CODE" (ngModelChange)="chartRoll.CURR_YR_CHART_CODE = $event">
            @if (CURR_YR_CHART_CODE_KEY_NOT_VALID && !chartRoll.CURR_YR_CHART_CODE) {
<small class="text-danger">Please provide Chart Code</small>
}
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button btn-sm" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button btn-sm" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
